/*
  Splash — la soglia fra Murals e Or.nami (spec §9.3).

  Perche' non ScrollTrigger: la posizione di scorrimento in questo tema la
  possiede Locomotive, e ScrollTrigger la vede solo di riflesso attraverso lo
  `scrollerProxy` di theme.liquid. La fonte di verita' e' quindi Locomotive: il
  pin legge da li', con `scroll.on('scroll')`, come gia' fa
  murals-main-description, e non dalla finestra - che con lo scorrimento
  morbido non si muove affatto.

  LA PAGINA E' LO SLIDER (2026-10-07). Fino a oggi la scena si teneva ferma per
  un budget di cambi e poi si sganciava verso la fascia di contenuti sotto la
  piega. Il committente ha tolto quella fascia dallo scroll (resta nell'HTML,
  per i lettori di schermo e i motori): sotto non c'e' piu' nulla da
  raggiungere, e la soglia fa come la referenza - le scene si rincorrono senza
  fine, e si entra da una porta.

  IL FERMO HA DUE STRADE, UNA PER MODALITA'.
    - Scorrimento morbido (desktop): il documento non scorre affatto,
      Locomotive trasla i contenitori, e sticky non si attiverebbe mai. La
      scena si trasla a mano: Locomotive ci avvisa nello stesso fotogramma in
      cui muove la pagina, e il fermo resta al pixel (misurato: 0px di scarto
      su 1.218 fotogrammi).
    - Scorrimento nativo (telefoni, tablet): il fermo lo fa `position: sticky`
      in CSS, dentro `.splash-pista`. Tradurre la scena a mano qui era un
      errore misurato: la pagina scorre sul thread del compositore e il nostro
      evento arriva un fotogramma dopo, quindi la scena sobbalzava di quanto si
      era mosso il dito - 30px nel 41% dei fotogrammi.
*/
(function () {
  var SCENES = 4;

  /*
    IL CAROSELLO NON FINISCE, ORA DAVVERO.

    Il giro sembrava gia' senza fine (due giri e poi lo sgancio), ma un pin
    davvero infinito avrebbe tolto la strada verso i contenuti. Senza contenuti
    sotto la ragione cade, e la pista diventa un nastro senza capi come quello
    della referenza (alto 910.348px e ricentrato quando ci si avvicina ai
    bordi).

    Qui la pista e' lunga CICLI giri di quattro scene e si parte dal centro.
    A meno di MARGINE giri da un bordo, la posizione salta indietro o avanti di
    un numero intero di giri: le scene sono le stesse, il salto non si vede, e
    il nastro non arriva mai in fondo.
  */
  var CICLI = 24;
  var MARGINE = 4;

  function init() {
    var section = document.querySelector('[data-splash]');
    if (!section) return;

    var stage = section.querySelector('[data-splash-stage]');
    var ticker = section.querySelector('[data-splash-ticker]');
    var down = section.querySelector('[data-splash-down]');
    var cols = section.querySelectorAll('[data-scenes]');
    var budget = 0;
    var pista = 0;            // tratto in cui la scena e' trattenuta: tutto il nastro
    var altezzaPasso = 0;     // px di scroll per un cambio di scena: l'altezza della scena
    var lastY = 0;
    var posizionato = false;

    // Locomotive, se presente. Si legge dal globale `scroll` di theme.liquid,
    // com'e' gia' uso in murals-main-description.
    var loco = (typeof scroll !== 'undefined' && scroll && typeof scroll.on === 'function') ? scroll : null;

    // Modalita' nativa: niente `has-scroll-smooth` sull'html. Si rilegge ogni
    // volta (costa niente) invece di fissarla all'avvio, cosi' regge anche se
    // Locomotive cambiasse contesto dopo.
    function nativo() { return !document.documentElement.classList.contains('has-scroll-smooth'); }

    // Movimento ridotto: niente pin e niente nastro. La soglia e' una
    // schermata ferma, con la prima scena di ciascuna porta: la stessa pagina,
    // piu' calma, e nessun movimento da cui doversi difendere.
    var senzaMoto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Il nastro si ricostruisce dal centro a ogni visita: una posizione
    // ripristinata dal browser cadrebbe in un punto qualunque, e su telefono
    // arriverebbe dopo la nostra.
    if (!senzaMoto && 'scrollRestoration' in history) history.scrollRestoration = 'manual';

    /*
      IL MOTORE DELLA SCOPERTA: QUELLO DELLA REFERENZA (2026-10-07).

      La referenza per questo effetto e' mersi-architecture.com, indicata dal
      committente il 2026-08-28. Il suo codice (Webflow, Lenis 1.2.3, GSAP;
      letto il 2026-10-07) fa quattro cose, e la soglia fa le stesse:

        1. LA SCOPERTA E' LINEARE. Un'altezza di schermo di scroll e' un
           cambio di scena, e ogni pixel di scroll sposta il bordo della
           stessa quantita'. Una versione precedente aveva soste e curve: a
           ogni cambio una zona morta in cui si scorreva e non succedeva nulla,
           letta - giustamente - come una resistenza a gradini.
        2. LA MORBIDEZZA E' TUTTA DELLO SCORRIMENTO. Lenis plana ogni tacca in
           2,5s su una curva esponenziale, cioe' con una costante di tempo di
           0,36s. Qui la stessa planata la fa Locomotive, col lerp tarato su
           quella costante. Un secondo smorzamento sommato al primo partiva in
           ritardo sulla mano: altra resistenza.
        3. A GESTO FINITO, MAI A META'. Mezzo secondo dopo l'ultima tacca la
           scena a meta' si completa o torna indietro (vedi `assesta`).
        4. UNCOVER, NON SLIDE. La scena nuova si scopre sopra la vecchia e
           l'immagine resta ferma: si muove solo il bordo. La referenza lo fa
           con `clip-path`; qui con due traslazioni opposte - la finestra
           avanza, l'immagine dentro arretra di altrettanto - che danno lo
           stesso fotogramma ma le compone il compositore, senza ridipingere.

      Niente zoom, ombre o veli: la referenza non li ha, e il committente
      aveva gia' chiesto di togliere la scala perche' sporcava.
    */
    var TAU = 0.36;               // s - costante di tempo della planata (referenza: 2,5s esponenziale)
    var ATTESA_ROTELLA = 500;     // ms dall'ultima tacca prima di assestare (referenza: 500)
    var ATTESA_DITO = 180;        // ms di quiete, a dito sollevato, prima di assestare
    /*
      LA SOGLIA DI COMPLETAMENTO: 30% NEL VERSO DEL GESTO (2026-10-07).

      La referenza completa oltre la meta', in entrambi i versi. Il committente
      ha chiesto uno scroll un poco piu' facile: oltre il 30% del cambio, nel
      verso in cui si sta scorrendo, la scena si completa da sola. Sotto torna
      indietro, cosi' una tacca sola (13% su un monitor da 900px) non basta e
      il gesto minimo non diventa un salto - era il difetto "nervosetto" di
      un aggancio che scattava a ogni spinta.
    */
    var SOGLIA = 0.3;

    var altezze = [];
    var scenePerColonna = [];
    for (var c0 = 0; c0 < cols.length; c0++) {
      scenePerColonna.push(Array.prototype.slice.call(cols[c0].querySelectorAll('.splash-scene')));
    }

    /*
      LA PLANATA NON DIPENDE DALLO SCHERMO.

      Locomotive applica il lerp una volta per fotogramma, quindi su un
      monitor a 120Hz la stessa cifra planerebbe in meta' tempo. Il lerp si
      ricava dalla costante di tempo e dalla durata vera del fotogramma,
      stimata all'avvio e corretta mentre si scorre. Solo su questa pagina:
      ogni pagina crea il proprio Locomotive.
    */
    var fotogramma = 1 / 60;      // s, stimato
    var ultimoEvento = 0;
    function taraPlanata() {
      if (senzaMoto || !loco || !loco.scroll || nativo() || typeof loco.scroll.lerp !== 'number') return;
      loco.scroll.lerp = 1 - Math.exp(-fotogramma / TAU);
    }
    taraPlanata();
    if (!senzaMoto && window.requestAnimationFrame) {
      var campioni = [], tPrec = 0;
      var sonda = function (t) {
        if (tPrec) campioni.push(t - tPrec);
        tPrec = t;
        if (campioni.length < 20) { requestAnimationFrame(sonda); return; }
        campioni.sort(function (a, b) { return a - b; });
        var mediana = campioni[campioni.length >> 1];
        if (mediana > 4 && mediana < 50) fotogramma = mediana / 1000;
        taraPlanata();
      };
      requestAnimationFrame(sonda);
    }

    // Una scena visibile: la finestra traslata di t, l'immagine di -t. A
    // riposo t vale 0 ma la traslazione resta, cosi' i livelli delle scene
    // visibili non nascono e muoiono a ogni cambio.
    function poni(sc, z, t) {
      if (sc.style.visibility !== 'visible') sc.style.visibility = 'visible';
      if (sc.style.zIndex !== z) sc.style.zIndex = z;
      sc.style.transform = 'translate3d(0,' + t.toFixed(2) + 'px,0)';
      var im = sc.firstElementChild;
      if (im) im.style.transform = 'translate3d(0,' + (-t).toFixed(2) + 'px,0)';
    }
    function togli(sc) {
      if (sc.style.visibility === 'hidden') return;
      sc.style.visibility = 'hidden';
      sc.style.zIndex = '0';
      sc.style.transform = '';
      if (sc.firstElementChild) sc.firstElementChild.style.transform = '';
    }

    function dipingi(vc) {
      if (!(vc > 0)) vc = 0;
      // A un soffio dal confine si e' sul confine: un bordo a mezzo pixel
      // lascerebbe un filo della scena dopo.
      var r = Math.round(vc);
      if (Math.abs(vc - r) < 0.002) vc = r;
      var k = Math.floor(vc), f = vc - k;
      var cur = k % SCENES, inc = (k + 1) % SCENES;
      for (var c = 0; c < cols.length; c++) {
        var scene = scenePerColonna[c];
        var H = altezze[c] || cols[c].clientHeight || window.innerHeight;
        // Il bordo sale nella colonna 'up' - la scena nuova si scopre dal
        // basso - e scende nell'altra: il moto contrapposto delle due porte.
        var t = (1 - f) * H * (cols[c].dataset.dir === 'up' ? 1 : -1);
        for (var j = 0; j < scene.length; j++) {
          if (j === inc && f > 0) poni(scene[j], '2', t);
          else if (j === cur) poni(scene[j], '1', 0);
          else togli(scene[j]);
        }
      }
    }

    // Le immagini si decodificano subito: la prima volta che una scena si
    // scopre, il browser non deve fermarsi a decomprimerla a meta' gesto.
    if (!senzaMoto) {
      for (var c1 = 0; c1 < scenePerColonna.length; c1++) {
        for (var j1 = 0; j1 < scenePerColonna[c1].length; j1++) {
          var im1 = scenePerColonna[c1][j1].firstElementChild;
          if (im1 && typeof im1.decode === 'function') im1.decode().catch(function () {});
        }
      }
    }

    // Il fermo. Con lo scorrimento morbido si trasla la scena di +y, tanto
    // quanto la pagina e' salita. Con quello nativo non si tocca: la tiene
    // ferma `position: sticky`, dal compositore, senza il fotogramma di
    // ritardo che la faceva tremare (vedi in cima).
    function pin(y) {
      if (senzaMoto) return;
      var held = Math.max(0, Math.min(pista, y));
      if (nativo()) {
        if (stage.style.transform) stage.style.transform = '';
      } else {
        stage.style.transform = 'translate3d(0,' + held + 'px,0)';
      }
    }

    function render(y) {
      lastY = y;
      if (senzaMoto) return;
      pin(y);
      // Il bordo si dipinge subito, nello stesso evento: la morbidezza e' gia'
      // nello scorrimento (vedi il motore in cima).
      if (altezzaPasso > 0) dipingi(y / altezzaPasso);
    }

    // Dove sta andando la pagina: il bersaglio di Locomotive con lo
    // scorrimento morbido, la posizione della finestra con quello nativo.
    function bersaglio() {
      if (nativo() || !loco || !loco.scroll || !loco.scroll.instance) return window.scrollY;
      return loco.scroll.instance.delta.y;
    }
    // Manda la pagina in `meta` con la stessa planata della mano: spostando
    // il bersaglio di Locomotive, o con lo scorrimento morbido del browser.
    function vaiVerso(meta) {
      if (nativo()) { window.scrollTo({ top: meta, behavior: 'smooth' }); return; }
      if (!loco || !loco.scroll || !loco.scroll.instance) return;
      var s = loco.scroll;
      s.instance.delta.y = meta;
      if (!s.isScrolling && typeof s.startScrolling === 'function') s.startScrolling();
    }
    // La mette in `y` subito, senza planata: la prima collocazione.
    function colloca(y) {
      lastY = y;
      if (nativo()) { window.scrollTo(0, y); return; }
      if (!loco || !loco.scroll || typeof loco.scroll.setScroll !== 'function') return;
      loco.scroll.setScroll(0, y);
      if (typeof loco.update === 'function') loco.update();
    }

    function centro() { return Math.round(CICLI / 2) * SCENES * altezzaPasso; }
    // Quanto saltare per tornare verso il centro: zero finche' si e' lontani
    // dai bordi, altrimenti un numero intero di giri.
    function scartoDalCentro(y) {
      var giro = SCENES * altezzaPasso;
      if (senzaMoto || !(pista > 0) || !(giro > 0)) return 0;
      if (y >= MARGINE * giro && y <= pista - MARGINE * giro) return 0;
      return Math.round((centro() - y) / giro) * giro;
    }

    /*
      A GESTO FINITO LA SCENA NON RESTA A META'.

      Come nella referenza: mezzo secondo dopo l'ultima tacca, se la soglia e'
      fra due scene, si completa o torna indietro (vedi SOGLIA). Cambia il
      come. La referenza ferma Lenis, anima la scena con GSAP in 0,8s e poi
      teletrasporta lo scorrimento; qui si sposta soltanto il BERSAGLIO di
      Locomotive sul confine, e la pagina ci arriva con la stessa planata della
      mano. Nessun secondo motore, nessuno scatto alla consegna, e una mano che
      riprende a scorrere a meta' assestamento si somma al movimento invece di
      scontrarsi con lui.

      Si decide sul bersaglio, non sulla posizione: il bersaglio dice dove la
      mano ha mandato la pagina, la posizione e' ancora in volo. Il verso si
      legge da dove il gesto e' cominciato (`origine`).
    */
    function confine(y, da) {
      if (!(pista > 0) || !(altezzaPasso > 0)) return null;
      var g = y / altezzaPasso, k = Math.floor(g), f = g - k;
      var verso = (da === null) ? 0 : (y > da + 0.5 ? 1 : (y < da - 0.5 ? -1 : 0));
      var limite = verso > 0 ? SOGLIA : (verso < 0 ? 1 - SOGLIA : 0.5);
      return Math.max(0, Math.min(pista, Math.round((f >= limite ? k + 1 : k) * altezzaPasso)));
    }

    var timerAssesta = null;
    var dita = 0;
    var origine = null;         // il bersaglio quando il gesto e' cominciato
    function inizioGesto() { if (origine === null) origine = bersaglio(); }
    function programmaAssesta(ms) {
      clearTimeout(timerAssesta);
      timerAssesta = setTimeout(assesta, ms);
    }
    function assesta() {
      if (senzaMoto) return;
      var da = origine;
      if (nativo()) {
        // Su touch lo scorrimento e' del browser: lo si accompagna al confine
        // solo a dito sollevato e a planata finita. Ferma sul confine, la
        // pagina si ricentra se serve - qui e non durante la planata, che un
        // salto di posizione interromperebbe.
        if (dita) return;
        origine = null;
        var yn = window.scrollY, mn = confine(yn, da);
        if (mn !== null && Math.abs(mn - yn) >= 1) { window.scrollTo({ top: mn, behavior: 'smooth' }); return; }
        var sn = scartoDalCentro(yn);
        if (sn) window.scrollTo(0, yn + sn);
        return;
      }
      origine = null;
      if (!loco || !loco.scroll || !loco.scroll.instance) return;
      var d = loco.scroll.instance.delta.y, m = confine(d, da);
      if (m === null || Math.abs(m - d) < 0.5) return;
      vaiVerso(m);
    }

    function onScroll(obj) {
      var y = (obj && obj.scroll) ? obj.scroll.y : window.scrollY;
      if (!nativo()) {
        var ora = performance.now(), dt = ora - ultimoEvento;
        ultimoEvento = ora;
        if (dt > 4 && dt < 50) { fotogramma += (dt / 1000 - fotogramma) * 0.05; taraPlanata(); }
      }
      render(y);
      /*
        IL NASTRO SI RICENTRA IN VOLO, con lo scorrimento morbido. Posizione e
        bersaglio saltano insieme dello stesso numero di giri: la distanza fra i
        due - cioe' la planata in corso - resta intatta, e nel fotogramma dopo
        Locomotive trasla i contenitori e la scena dello stesso salto, quindi
        sullo schermo non cambia nulla.
      */
      if (!nativo() && loco && loco.scroll && loco.scroll.instance) {
        var salto = scartoDalCentro(y);
        if (salto) {
          var inst = loco.scroll.instance;
          inst.scroll.y += salto;
          inst.delta.y += salto;
          lastY += salto;
          if (origine !== null) origine += salto;
        }
      }
      // Su touch la pagina plana da sola dopo il rilascio: ogni evento rinvia
      // l'assestamento, che parte quando lo scorrimento e' fermo davvero.
      if (nativo() && !dita) programmaAssesta(ATTESA_DITO);
    }

    if (!senzaMoto) {
      // In cattura, prima che Locomotive sposti il bersaglio: cosi' `origine`
      // e' davvero il punto da cui il gesto parte.
      window.addEventListener('wheel', function () {
        inizioGesto();
        programmaAssesta(ATTESA_ROTELLA);
      }, { passive: true, capture: true });

      window.addEventListener('touchstart', function (e) {
        dita = e.touches.length;
        inizioGesto();
        clearTimeout(timerAssesta);
      }, { passive: true });
      var rilascio = function (e) {
        dita = e.touches.length;
        if (!dita) programmaAssesta(nativo() ? ATTESA_DITO : ATTESA_ROTELLA);
      };
      window.addEventListener('touchend', rilascio, { passive: true });
      window.addEventListener('touchcancel', rilascio, { passive: true });

      /*
        DA TASTIERA, UNA SCENA PER TASTO. Locomotive sposta il bersaglio di
        240px con le frecce e di uno schermo con PagGiu' e lo spazio: lo si
        porta al confine successivo nel verso del tasto, cosi' nemmeno la
        tastiera lascia la soglia a meta'. PagGiu' resta com'era, perche' uno
        schermo e' gia' un cambio. Il controllo avviene dopo che Locomotive ha
        gestito il tasto: se il bersaglio non si e' mosso (un campo di testo,
        il tab) non si tocca nulla.
      */
      window.addEventListener('keydown', function () {
        if (nativo() || !loco || !loco.scroll || !loco.scroll.instance) return;
        var prima = loco.scroll.instance.delta.y;
        setTimeout(function () {
          var d = loco.scroll.instance.delta, dopo = d.y;
          if (dopo === prima || !(dopo > 0 && dopo < pista)) return;
          var g = dopo / altezzaPasso;
          var m = Math.round((dopo > prima ? Math.ceil(g - 0.001) : Math.floor(g + 0.001)) * altezzaPasso);
          if (Math.abs(m - dopo) >= 0.5) d.y = m;
        }, 0);
      }, true);
    }

    /*
      IL BADGE PORTA ALLA SCENA DOPO.

      Saltava ai contenuti sotto la piega; ora sotto non c'e' nulla, e "scroll
      down to explore" resta vero: scorrere esplora le scene. Cliccarlo fa lo
      stesso passo che fa lo scroll, con la stessa planata - per chi preferisce
      un pulsante alla rotella, e per chi naviga da tastiera.
    */
    if (down && !senzaMoto) {
      down.addEventListener('click', function () {
        if (!(altezzaPasso > 0)) return;
        var g = bersaglio() / altezzaPasso;
        vaiVerso(Math.max(0, Math.min(pista, Math.round((Math.floor(g + 0.001) + 1) * altezzaPasso))));
      });
    }

    // La misura va rifatta: allo `defer` il corpo e' ancora in `loading` e la
    // scena misura zero, quindi una misura presa una volta sola potrebbe
    // restare a zero. Si ricalcola al `load` e a ogni ridimensiona, e si avvisa
    // Locomotive perche' l'altezza della pagina cambia con lei.
    function measure() {
      var h = stage.getBoundingClientRect().height || window.innerHeight;
      // La scena su cui si e' adesso, da conservare se l'altezza cambia.
      var scena = (posizionato && altezzaPasso > 0) ? Math.round(lastY / altezzaPasso) : null;
      altezzaPasso = h;
      if (senzaMoto) {
        // Nessuna pista: la sezione e' alta quanto lo schermo e non scorre.
        budget = h;
        pista = 0;
        section.style.setProperty('--splash-budget', h + 'px');
        return;
      }
      // Il nastro: CICLI giri di quattro scene, piu' l'altezza della scena
      // stessa, che sta ferma sopra l'ultimo tratto.
      budget = h * (SCENES * CICLI + 1);
      pista = budget - h;
      section.style.setProperty('--splash-budget', budget + 'px');

      // L'AGGIORNAMENTO VA RIMANDATO AL FRAME DOPO.
      //
      // La riga sopra cambia l'altezza della pista, cioe' quella del
      // documento. Chiamando `update()` subito, Locomotive rimisura PRIMA
      // che il browser abbia applicato quell'altezza, e si tiene un limite piu'
      // corto della pagina vera (osservato: 3168 contro 3656). Un frame di
      // attesa lascia applicare l'altezza e la misura torna vera.
      var aggiorna = function () {
        if (loco && typeof loco.update === 'function') loco.update();
        // Il bordo si sposta in px: serve l'altezza vera di ogni colonna, che
        // sul telefono e' mezza scena (le porte sono impilate).
        for (var c = 0; c < cols.length; c++) altezze[c] = cols[c].clientHeight;
        // Alla prima misura si parte dal centro del nastro, sulla prima scena;
        // alle successive si resta sulla stessa scena anche se l'altezza e'
        // cambiata.
        var y = (scena === null) ? centro() : scena * altezzaPasso;
        if (!posizionato || Math.abs(y - lastY) > 0.5) colloca(y);
        posizionato = true;
        render(lastY);
      };
      if (window.requestAnimationFrame) window.requestAnimationFrame(aggiorna);
      else aggiorna();
    }

    // La posizione si legge da chi la possiede: Locomotive con lo scorrimento
    // morbido, la finestra con quello nativo. Prima si ascoltava solo
    // Locomotive anche in nativo, e un salto di scorrimento (un'ancora, la
    // ricerca nella pagina) non sempre arrivava: la scena restava ferma al
    // valore vecchio. La finestra invece avvisa sempre.
    if (loco) loco.on('scroll', function (obj) { if (!nativo()) onScroll(obj); });
    window.addEventListener('scroll', function () { if (!loco || nativo()) onScroll(null); }, { passive: true });

    /*
      IL MOVIMENTO CONTINUO SI PUO' FERMARE (2026-10-07).

      Il nastro scorre in 72s e il badge ruota in 18s, all'infinito. Si
      fermavano gia' fuori vista e col movimento ridotto, ma chi li aveva
      davanti non poteva fermarli: e' testo in movimento accanto ad altro
      contenuto (WCAG 2.2.2), e chi si avvicina per leggere il claim lo vedeva
      scappare.

      Tre ragioni per fermarsi, una sola regola: gira solo se nessuna vale.
        - pausa chiesta dal pulsante: vale finche' non lo si ripreme;
        - puntatore sopra (o focus da tastiera): il nastro si ferma per farsi
          leggere, il badge per farsi leggere e cliccare;
        - fuori vista: il nastro non impegna la GPU per niente.
      La fermata non e' uno stop secco: la velocita' scende a zero in 600ms,
      come un rullo che si ferma, e riparte allo stesso modo. Fuori vista
      invece si ferma di colpo, tanto non lo vede nessuno.
    */
    var track = section.querySelector('.splash-marquee__track');
    var anello = section.querySelector('.splash-down__ring');
    var pulsantePausa = section.querySelector('[data-splash-pausa]');
    var stato = { pausa: false, sopraNastro: false, sopraBadge: false, fuoriVista: false };

    function animazione(el) {
      if (!el || typeof el.getAnimations !== 'function') return null;
      var a = el.getAnimations();
      return a.length ? a[0] : null;
    }
    function verso(anim, aZero, ms) {
      if (!anim) return;
      cancelAnimationFrame(anim.__rampa);
      if (!ms) {
        if (aZero) anim.pause(); else { anim.playbackRate = 1; anim.play(); }
        return;
      }
      if (!aZero && anim.playState === 'paused') { anim.playbackRate = 0.001; anim.play(); }
      if (aZero && anim.playState === 'paused') return;
      var da = anim.playbackRate, a = aZero ? 0 : 1, t0 = performance.now();
      var passo = function (t) {
        var k = Math.min(1, (t - t0) / ms);
        var e = 1 - Math.pow(1 - k, 3);
        if (k >= 1) {
          if (aZero) { anim.pause(); anim.playbackRate = 1; } else anim.playbackRate = 1;
          return;
        }
        anim.playbackRate = Math.max(0.001, da + (a - da) * e);
        anim.__rampa = requestAnimationFrame(passo);
      };
      anim.__rampa = requestAnimationFrame(passo);
    }
    function aggiornaMoto(istantaneo) {
      var ms = istantaneo ? 0 : 600;
      verso(animazione(track), stato.pausa || stato.sopraNastro || stato.fuoriVista, stato.fuoriVista ? 0 : ms);
      verso(animazione(anello), stato.pausa || stato.sopraBadge, ms);
    }

    if (!senzaMoto) {
      if (ticker) {
        ticker.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { stato.sopraNastro = true; aggiornaMoto(); } });
        ticker.addEventListener('pointerleave', function () { if (stato.sopraNastro) { stato.sopraNastro = false; aggiornaMoto(); } });
      }
      if (down) {
        down.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { stato.sopraBadge = true; aggiornaMoto(); } });
        down.addEventListener('pointerleave', function () { if (stato.sopraBadge) { stato.sopraBadge = false; aggiornaMoto(); } });
        down.addEventListener('focus', function () { stato.sopraBadge = true; aggiornaMoto(); });
        down.addEventListener('blur', function () { stato.sopraBadge = false; aggiornaMoto(); });
      }
      if (pulsantePausa) {
        pulsantePausa.addEventListener('click', function () {
          stato.pausa = !stato.pausa;
          pulsantePausa.setAttribute('aria-pressed', stato.pausa ? 'true' : 'false');
          // Le etichette arrivano tradotte dal markup (soglia in italiano e
          // in inglese); l'italiano resta come ripiego.
          pulsantePausa.setAttribute('aria-label', stato.pausa
            ? (pulsantePausa.getAttribute('data-label-riprendi') || 'Riprendi il movimento')
            : (pulsantePausa.getAttribute('data-label-pausa') || 'Metti in pausa il movimento'));
          aggiornaMoto();
        });
      }
      if (track && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (voci) {
          stato.fuoriVista = !voci[0].isIntersecting;
          aggiornaMoto();
        }, { rootMargin: '120px' }).observe(track);
      }
    }

    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);

    // L'ALTEZZA DELLA PAGINA CAMBIA ANCHE DOPO `load`, E LOCOMOTIVE NON SE NE
    // ACCORGE DA SOLO.
    //
    // Le otto immagini della soglia arrivano quando arrivano, i caratteri si
    // sostituiscono, il banner dei cookie compare e sparisce: ogni volta il
    // contenitore cambia altezza. Locomotive tiene un limite calcolato una
    // volta, e se quel limite e' piu' corto della pagina una parte del nastro
    // diventa semplicemente irraggiungibile - nemmeno `scrollTo` ci arriva.
    // Osservato dal vivo: limite 503 contro un contenitore di 4082, cioe' la
    // pagina bloccata dopo mezza schermata.
    //
    // Invece di indovinare quando rimisurare, si osserva: al cambio d'altezza
    // del contenitore si aggiorna. Il confronto con l'ultima altezza nota evita
    // il ciclo, perche' `update()` puo' a sua volta toccare il layout.
    var contenitore = document.querySelector('[data-scroll-container]');
    if (loco && contenitore && 'ResizeObserver' in window) {
      var ultimaH = 0;
      var osservatore = new ResizeObserver(function () {
        var h = contenitore.getBoundingClientRect().height;
        if (Math.abs(h - ultimaH) < 2) return;
        ultimaH = h;
        if (typeof loco.update === 'function') loco.update();
      });
      osservatore.observe(contenitore);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
